export const AboutIntro = () => {
  return (
    <section data-testid="about-intro" className="bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-20">
        <div className="max-w-3xl space-y-5">
          <p data-testid="about-intro-paragraph-1" className="text-base sm:text-lg text-slate-600 leading-relaxed">
            RKG NATURALS is an agricultural products importer, exporter and wholesaler based in Maharashtra, India.
          </p>
          <p data-testid="about-intro-paragraph-2" className="text-base sm:text-lg text-slate-600 leading-relaxed">
            We connect reliable sourcing with buyers looking for quality Indian agricultural and natural products.
            Our business focuses on quality, reliability, proper sourcing, customer satisfaction and long-term
            business relationships.
          </p>
          <p data-testid="about-intro-paragraph-3" className="text-base sm:text-lg text-slate-600 leading-relaxed">
            We work to provide suitable sourcing and supply solutions according to product specifications,
            quantities, packaging requirements and buyer needs.
          </p>
        </div>
      </div>
    </section>
  );
};
